import React, { useState, useRef, useEffect, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../css/layout.css';


export function ItemDetailsModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);


    let [storefront, setStorefront] = useState(null);
    let [itemID, setItemID] = useState(null);
    let [itemName, setItemName] = useState(null);
    let [itemDescription, setItemDescription] = useState(null);
    let [vendorPartNum, setVendorPartNum] = useState(null);
    let [vendorName, setVendorName] = useState(null);
    let [vendorPhoneNumber, setVendorPhoneNumber] = useState(null);
    let [vendorAddress, setVendorAddress] = useState(null);
    let [vendorCity, setVendorCity] = useState(null);
    let [vendorCountry, setVendorCountry] = useState(null);
    let [costPerUnit, setCostPerUnit] = useState(null);
    let [qtyInStock, setQtyInStock] = useState(null);
    let [qtyInUse, setQtyInUse] = useState(null);
    let [dateCreated, setDateCreated] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [addedBy, setAddedBy] = useState(null);


    let [showItemDetails, setShowItemDetails] = useState(false);



function getItemDetailData() {

        //alert('In getEmployeeDetailData');
       // alert(props.data.itemID);
        //alert(employeeID);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74408_retail',
                user: acctID,
                xInventoryItemID: props.data.itemID,
                sessionID: sessionID,
            }),
        }
        
        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewItemDetailsData((prevViewItemDetailsData) => {
                    return prevViewItemDetailsData.concat({
                        itemID: cols[0],
                        itemName: cols[1],
                        vendorPartNum: cols[2],
                        vendorName: cols[3],
                        costPerUnit: parseFloat(cols[4]).toFixed(2),
                        qtyInStock: cols[5],
                        qtyInUse: cols[6],
                        dateReplenished: cols[7],
                    })
                });
            } 
        })
    }




useEffect(() =>  {
        
    getItemDetailData();   

}, [])

//alert('In Management _ Inventory');
//alert(authenticatedMerchent_context.selectedTutorial?.tutorial_id);
//alert(authenticatedMerchent_context.selectedTutorial?.details?.step_1);
//alert(authenticatedMerchent_context.device);

        return (
            <React.Fragment>
        {props.openModal == true ?
        (
                <IonModal id='showItemDetails' isOpen={ props.openModal}>

                <IonHeader style={{color: "black"}}>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonText>ITEM DETAILS</IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonHeader>
                <IonContent className='grid_content_details'>

                            <IonGrid >
                                <IonRow>
                                            <IonCol >Item ID</IonCol>
                                            <IonCol >Date Stocked</IonCol>
                                </IonRow>
                                {viewItemDetailsData.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            <IonCol >{detailData.itemID}</IonCol>
                                            <IonCol >{detailData.dateReplenished}</IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                                <IonRow>
                                    <IonCol size='6'>
                                        <h4>Details</h4>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <h4>Stock Items</h4>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonSlides>
                                        <IonSlide>
                                        {viewItemDetailsData.map((detailData) =>   {
                                            return (
                                            <IonGrid >
                                                <IonRow >
                                                    <IonCol >Category</IonCol>
                                                    <IonCol >Value</IonCol>
                                                    <IonCol >Action</IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Name</IonCol>
                                                    <IonCol >{detailData.itemName}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Part Number</IonCol>
                                                    <IonCol >{detailData.vendorPartNum}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol > Vendor</IonCol>
                                                    <IonCol >{detailData.vendorName}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Cost Per Unit</IonCol>
                                                    <IonCol >{detailData.costPerUnit}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Qty-IN-Stock</IonCol>
                                                    <IonCol >{detailData.qtyInStock}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                                <IonRow >
                                                    <IonCol >Qty-IN-Use</IonCol>
                                                    <IonCol >{detailData.qtyInUse}</IonCol>
                                                    <IonCol >
                                                        <IonButton > Update </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            </IonGrid>
                                                    )
                                                }
                                            )}
                                            </IonSlide>
                                        </IonSlides>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            </IonContent>
                    <IonFooter className='appFooter'>
                        <IonGrid>
                                <IonRow>
                                    <IonCol size="12">
                                        <IonButton onClick={() => props.closeModal(false)}>Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                    </IonFooter>
                </IonModal>
                ) : null}

            </React.Fragment>
        )
    }   